import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../lib/reacti18n';
import Tabs from '../../contactUs/components/common/Tabs';
import { trackLink } from '../../lib/analytics-helper';

const keys = [
  'related',
  'community',
];

const toggleLabels = [
  i18n.message('smarthelp/contentToggle.content.label.related'),
  i18n.message('smarthelp/contentToggle.content.label.community'),
];

class ToggleComponent extends Component {

  static getLabels(labels) {
    return labels.map((key, priority) => ({
      key: keys[priority],
      priority,
      label: key,
    }));
  }
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(index) {
    trackLink({ id: 'articlePage', link: `smarthelp-article-page|toggle-related-community|${index.key}` });
    this.props.clickHandler(index.key);
  }
  renderToggle(labels, selected) {
    return (
      <div className="content-toggle-container">
        <Tabs
          labelArray={labels}
          selected={selected}
          onClick={this.onClickHandler}
        />
      </div>
    );
  }
  render() {
    if (!this.props.display) {
      return null;
    }
    return (
      <div className="toggle-related">
        {this.renderToggle(ToggleComponent.getLabels(toggleLabels), this.state.selectedTab)}
        <div id="related-content" />
      </div>
    );
  }
}
ToggleComponent.propTypes = {
  display: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired,
};
export default ToggleComponent;
